/**
 * Cấu hình lời thoại MÁY TRẠM ĐƠN HÀNG.
 *
 * Case máy vò (`machine_finishing`) tách sang `settings/production-station-voice`
 * và case sổ xưởng (`packaging_log_entry`) sang `settings/warehouse-station-voice`
 * — ba bộ phận khác nhau, không ai phải lướt qua cấu hình của bộ phận kia.
 */

import { createFileRoute } from '@tanstack/react-router'

import { StationVoiceSettingsView } from '@/components/station-voice/station-voice-settings-view'
import { isOrderStationCase } from '@/lib/station-voice-cases'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/settings/station-voice',
)({ component: StationVoicePage })

function StationVoicePage() {
    return (
        <StationVoiceSettingsView
            title={m.station_voice_title()}
            includeCase={isOrderStationCase}
        />
    )
}
